module.exports = __webpack_public_path__ + "img/Flag_of_the_Falkland_Islands.b463b303.svg";